import { createStandardAction, ActionType } from 'typesafe-actions';
import { AdminToolsTab } from './AdminToolsState';

export const AdminToolsBlockActions = {
  setTab: createStandardAction('@admin/tab/set')<AdminToolsTab>(),
};

export type AdminToolsBlockAction = ActionType<typeof AdminToolsBlockActions>;
